<template>
  <!-- Pins the collection owner's branding band below the app bar on mobile and
       in the extension popup, above the collection description. Renders nothing
       without branding, so it never adds a row to an unbranded page.
       Carries no gutter: the band is edge to edge, and the surrounding columns
       keep their own spacing. See useBrandingPlacement. -->
  <v-col v-if="branding" cols="12" :class="brandingBarClass" class="pa-0" :style="offsetStyle">
    <BrandingHeader :branding="branding" class="StickyBrandingBar__band" />
  </v-col>
</template>

<script setup>
import BrandingHeader from '@/components/global/BrandingHeader.vue'
import { useStickyTop, STICKY_BRANDING_BAR_CLASS } from '@/composables/useStickyTop'

defineProps({
  // Resolved branding to pin, or null. Use `pinnedBranding` from
  // @/composables/useBrandingPlacement.
  branding: {
    type: Object,
    default: null,
  },
})

// Bound rather than written literally: StickyFilterBar finds this bar by the
// same constant to stack below it.
const brandingBarClass = STICKY_BRANDING_BAR_CLASS

const { offsetStyle } = useStickyTop()
</script>

<style lang="scss" scoped>
.StickyBrandingBar {
  @include sticky-page-bar;
}

// The band is edge to edge. This column sits inside the page container (`pa-4`)
// but is hoisted 12px back out by the row's negative gutter, so 4px of bleed
// closes the remaining inset on each side. Only lands because BrandingHeader
// keeps `width: auto` -- an explicit width would over-constrain the box and the
// browser would drop the right margin.
// Not `100vw`: that counts the scrollbar too and would add horizontal overflow
// on a narrow desktop window, which reports as mobile.
$container-bleed: 4px;

.StickyBrandingBar__band {
  margin-inline: -$container-bleed;
}
</style>
